import auth from "./auth";
import challengeIdeaFilters from "./challengeIdeaFilters";
import entry from "./entry";
import messages from "./messages";
import organisations from "./organisations";
import user from "./user";

const actions = {
  auth,
  user,
  messages,
  organisations,
  challengeIdeaFilters,
  entry,
};
export default actions;
